import { Component } from '@angular/core';
import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { Subject } from 'rxjs';
import { ModalCloseButtonOptions } from '../edit-add-record-popup/edit-add-record-popup-helper';
import { AdminConstant } from '../../../../constants/admin-constants';

@Component({
  selector: 'app-name-validation-popup',
  templateUrl: './name-validation-popup.component.html',
  styleUrl: './name-validation-popup.component.less',
})
export class NameValidationPopupComponent {
  private readonly unsubscriber$: Subject<void> = new Subject<void>();
  modalCloseButtonOptions: ButtonOptions = ModalCloseButtonOptions;
  emptyString: string = AdminConstant.EMPTY_SPACE;

  constructor(private readonly modalService: ModalService) {}

  closeModal(): void {
    this.modalService.close();
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}
